/** Seconds a drafting row may remain in-flight before it is treated as stale.
 * Override via DRAFTING_TTL_SECONDS env var (plain integer) for testing or TSE tuning.
 * Both api-reaction-action (force_retry gate) and api-digest-reactions (GET status view)
 * import this so the two handlers always agree on the staleness threshold.
 */
export const DRAFTING_TTL_SECONDS = Number(process.env['DRAFTING_TTL_SECONDS'] ?? '300');
